export default __webpack_public_path__ + "static/media/slider2.99ef19b7.jpg";